module.exports = __webpack_public_path__ + "d4c5b5d260b0c2067f049223b8b12f76.pdf";